import {
  jordanCountryCode,
  jordanCountryShortCode,
} from "../../../../common/Utils/ApiConstants";

export const InitialValues = {
  companyId: "",
  name: "",
  dob: "",
  designation: "",
  department: "",
  mobile: "",
  countryCode: jordanCountryCode,
  mobileShortCode: jordanCountryShortCode,
  companyNumber: "",
  companyExtension: "",
  hrMobile: "",
  hrMobileCountryCode: jordanCountryCode,
  hrMobileShortCode: jordanCountryShortCode,
  alternateMobileShortCode: jordanCountryShortCode,
  alternateMobileCountryCode: jordanCountryCode,
  alternateMobile: "",
  email: "",
  residanceAddress: "",
  resAddress: "",
  resState: "",
  workState: "",
  resCountry: "",
  apartmentRes: "",
  apartmentWork: "",
  workCountry: "",
  resCity: "",
  workCity: "",
  resZipCode: "",
  workZipCode: "",
  workAddress: "",
  gender: "Male",
  Male: false,
  Female: false,
  reportTo: ""
};

export const options = [
  {
    label: "www.flipkart.com",
    value: "www.flipkart.com",
  },
  {
    label: "www.google.com",
    value: "www.google.com",
  },
  {
    label: "www.amazon.in",
    value: "www.amazon.in",
  },
  {
    label: "www.Myntra.com",
    value: "www.Myntra.com",
  },
];

export const radioOptions = ["Male", "Female"];
export const centerContent = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  alignContent: "center",
  fontWeight: "500",
  flex: 1,
};
export const ManagerUser = "MANAGER";
